import {
  PROVIDERS_FETCHED_SUCCESS,
  PROVIDERS_FETCHED_FAILURE,
} from '../actions/types';

const initialState = 'NONE';

export default function providersFetchedReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case PROVIDERS_FETCHED_SUCCESS:
      return payload;
    case PROVIDERS_FETCHED_FAILURE:
      return 'NONE';

    default:
      return state;
  }
}
